import { getApps, initializeApp } from "firebase/app";
import {
  GoogleAuthProvider,
  User,
  getAuth,
  onAuthStateChanged,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { createContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { eraseCookie, setCookie } from "./utility/cookies";

//
// AUTH INIT
//
const firebaseConfig = {
  apiKey: "AIzaSyBQQerB2UBSzCwqK2eBhPeHCqvOkNIieGo",
  authDomain: "my-website-340021.firebaseapp.com",
};
let app: any;
const apps = getApps();
if (!apps.length) app = initializeApp(firebaseConfig);
else app = apps[0];
const auth = getAuth(app);

const signedInLSKey = "signed-in";
let prevSignedIn = Boolean(localStorage.getItem(signedInLSKey));
auth.onIdTokenChanged(async (user) => {
  // console.log("id token changed", user);
  if (user) {
    const jwt = await user.getIdToken();
    // localStorage.setItem("id_token", jwt);
    // Expires in one hour.
    setCookie("authorization", "Bearer " + jwt, 3600000);
    if (!prevSignedIn) {
      toast.success(`Signed in as ${user.email}!`);
      prevSignedIn = true;
      localStorage.setItem(signedInLSKey, "true");
    }
  } else {
    // localStorage.removeItem("id_token");
    eraseCookie("authorization");
    if (!!prevSignedIn) {
      toast.success(`Signed out!`);
      prevSignedIn = false;
      localStorage.removeItem(signedInLSKey);
    }
  }
});

//
// Types
//
interface AppProviderProps {
  children?: any;
}
interface IAppContext extends AppProviderProps {
  signIn: () => Promise<void>;
  signOut: () => void;
  user: User | null;
  authError: string;
  isMobileView: boolean;
}

//
// Context
//
export const AppContext = createContext({} as IAppContext);

/*** Mobile breakpoint width in pixels. */
const mobileWidth = 700;
const checkIsMobileView = () => window.innerWidth < mobileWidth;

//
// Provider
//
export const AppContextProvider = (props: AppProviderProps) => {
  //
  // MOBILE
  //
  const [isMobileView, setIsMobileView] = useState(checkIsMobileView());
  useEffect(() => {
    const onWindowResize = () => {
      const nowIsMobile = checkIsMobileView();
      setIsMobileView(nowIsMobile);
    };
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, [isMobileView]);

  const [user, setUser] = useState<User | null>();
  useEffect(() => {
    // onAuthStateChanged(auth, updatePageWithAuthStatus);
    onAuthStateChanged(auth, setUser);
  }, [auth, setUser]);

  const [authError, setAuthError] = useState("");
  async function signIn() {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      // Could redirect to the game here.
      // window.location.href = "/game";
      // window.location.href = "/";
      // setAuthError("");
    } catch {
      setAuthError("Invalid user.");
    }
  }

  // Wait while the auth loads.
  if (user === undefined) return null;
  // console.log("Current user:", user);
  return (
    <AppContext.Provider
      value={{
        isMobileView,
        signIn,
        signOut: () => signOut(auth),
        user,
        authError,
      }}
    >
      {/* <br />
			{!!user ? (
				<>
					<button onClick={() => signOut(auth)}>SIGN OUT</button>
					<br />
					Welcome,&nbsp;{user.email}
				</>
			) : (
				<>
					<button onClick={() => signIn()}>SIGN IN</button>
					<br />
					No user signed in.
				</>
			)}
			<br /> */}
      {/* <div id="message" /> */}
      {props.children}
    </AppContext.Provider>
  );
};
